import React, { useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import SearchIcon from "@assets/icons/SearchIcon";
const CustomSearchInput = ({ onSearch }) => {
  const [search, setSearch] = useState("");

  const { t } = useTranslation();

  return (
    <div className="search-container">
      <SearchIcon />
      <input
        value={search}
        onChange={(e) => {
          onSearch(e.target.value);
          setSearch(e.target.value);
        }}
        className="search-input"
        placeholder={t("app.search")}
      />
    </div>
  );
};

export default CustomSearchInput;
